import { useCallback, useEffect } from 'react';

import styled from '@emotion/styled';
import { callNativeHandler } from '@myrealtrip/marketing-log';
import { useWebView } from '@myrealtrip/device-detect';
import { Loader } from '@myrealtrip/web-ui';

import type { ChannelsRequestParams } from '~models/MessengerDto';
import useCreateChannel from '~queries/messenger/useCreateChannel';
import useUsersMeQuery from '~queries/messenger/useUsersMe';

interface Props {
  param: ChannelsRequestParams;
}

function Android({ param }: Props) {
  const { isWebView } = useWebView();
  const { data } = useUsersMeQuery(isWebView);
  const isLoggedIn = Boolean(data?.id);
  const { createAndOpenChannel, isLoading } = useCreateChannel();

  const goBack = useCallback(() => {
    callNativeHandler('close');
  }, []);

  const closeBridge = () => {
    callNativeHandler('close');
  };

  const openChannel = async () => {
    window.location.reload();
    await createAndOpenChannel?.(param, goBack, true);
  };

  useEffect(() => {
    async function fetchChannel() {
      await createAndOpenChannel?.(param, goBack, true);
    }

    fetchChannel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      {isLoading ? (
        <Loader />
      ) : isLoggedIn ? (
        <>
          <Content>
            상담을 잘 마치셨나요?
            <br />
            다른 상품을 살펴보기 위해 이 창을 닫아주세요
          </Content>
          <Button onClick={closeBridge}>닫기</Button>
        </>
      ) : (
        <>
          <Content>
            문의하기를 계속 진행하시려면
            <br />
            아래 버튼을 클릭해 주세요.
          </Content>
          <Button onClick={openChannel}>문의하기</Button>
        </>
      )}
    </Container>
  );
}

function Ios({ param }: Props) {
  const { createAndOpenChannel, isLoading } = useCreateChannel();

  const closeBridge = () => {
    callNativeHandler('close');
  };

  useEffect(() => {
    const entries = performance.getEntriesByType('navigation')[0];
    const entriesNavigationTiming = entries as PerformanceNavigationTiming;
    if (entriesNavigationTiming.type === 'navigate') {
      createAndOpenChannel?.(param);
    } else {
      callNativeHandler('close');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Content>
            상담을 잘 마치셨나요?
            <br />
            다른 상품을 살펴보기 위해 이 창을 닫아주세요
          </Content>
          <Button onClick={closeBridge}>닫기</Button>
        </>
      )}
    </Container>
  );
}

const Bridge = {
  Ios,
  Android,
};

export default Bridge;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100vw;
  min-height: 100dvh;
  font-size: 18px;
`;

const Content = styled.div`
  line-height: 1.5;
`;

const Button = styled.button`
  margin: 50px auto 0;
  padding: 10px 30px;
  border-radius: 999px;
  background-color: #141719;
  color: #ffffff;
  border: none;
  font-size: 16px;
`;
